import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdditionalDocsService } from './additional-docs.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-additional-docs',
    templateUrl: './additional-docs.component.html'
})
export class AdditionalDocsComponent implements OnInit {
    docNames: string[];
    downloadingDoc: boolean[];
    constructor(
        private route: ActivatedRoute,
        private additionalDocsService: AdditionalDocsService
    ) {}

    ngOnInit() {
        this.docNames = this.route.snapshot.data['docNames'];
        this.downloadingDoc = new Array(this.docNames.length);
        this.downloadingDoc.fill(false);
    }

    open(docName: string, docIndex: number) {
        this.downloadingDoc[docIndex] = true;
        this.additionalDocsService.getDoc(docName)
            .finally(() => {
                this.downloadingDoc[docIndex] = false;
            })
            .subscribe((doc: Blob) => {
                FileSaver.saveAs(doc, docName);
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/additional-docs/additional-docs.component.ts